import { Icon, IconName, IconProps, pxToRem } from '@lbcamden/lib-react';

export const itemActionLabel = (icon: IconName, text: string, iconProps?: Partial<IconProps>) => (
  <>
    <Icon icon={icon} $color="primary" width={pxToRem(18)} {...iconProps} />
    {text}
  </>
);
